
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gGh9gw7apLLMhCEaW6OOTEPlDf1Pss_45BhXoXSIO21fQAMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index1aKZtMSGzdKh7PvqAoDKEO9FSmlI3er05Yplxa4q36YMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searcha2PKNksnR5M6V0Bzt3IKO2jbXk7fhpGqbFIBQ2H9I80Meta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexj_45fVupSCcokhX9lRzj_1bnzvLp57Y0wo78H_45z9vXXd4Meta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_932Lc6w4Xue1iag1faGgIC72PHDDgRIeK6LdTMWJTo1BgMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexLNZlDEnUAMK4rDU5rh5C8_45mgoBu7mzvxG_45tf28SsQToMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_937laEel4dv_qBboE7mrQKI8f0nWHrn_U5YxCTibYUnMoMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexzYZgViKTcYaV72q1wrYb9xm96Mj4eM4A7f0JJcGL1nMMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93EbRY6SBcCfpn_LotSnSYnphszrosu7YWHv_45NiGV2DrEMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexkApjf83G485F_N6eEjuIFsYvthtv4BAr47C96HU_45_VUMeta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexNwZu4WY0nmTld1oErQ9YNvOtZQcnhgCS_45VgLI41EXm0Meta } from "/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexLNZlDEnUAMK4rDU5rh5C8_45mgoBu7mzvxG_45tf28SsQToMeta || {},
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexzYZgViKTcYaV72q1wrYb9xm96Mj4eM4A7f0JJcGL1nMMeta || {},
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexkApjf83G485F_N6eEjuIFsYvthtv4BAr47C96HU_45_VUMeta || {},
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexNwZu4WY0nmTld1oErQ9YNvOtZQcnhgCS_45VgLI41EXm0Meta || {},
    component: () => import("/codebuild/output/src2257683664/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]